import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (event) => {
    event.preventDefault();
    const term = query.trim();
    if (!term) return;
    navigate(`/learn?search=${encodeURIComponent(term)}`);
  };

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="not-found-page">
      <SEOHead title="Page Not Found | Flash Funding" description="The page could not be found. Explore core finance pathways instead." canonical="/404" />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-testid="not-found-main-section">
        <h1 className="text-5xl sm:text-6xl font-extrabold text-white mb-4">404</h1>
        <p className="text-white/70 mb-8">We couldn’t find that page. Try one of the core finance pathways below.</p>

        <form onSubmit={handleSearch} className="flex gap-2 max-w-lg mx-auto mb-8" data-testid="not-found-search-form">
          <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search finance guides" className="bg-navy-800 border-purple-500/30 text-white" data-testid="not-found-search-input" />
          <Button type="submit" className="bg-purple-600 hover:bg-purple-500 text-white" data-testid="not-found-search-submit">Search</Button>
        </form>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="not-found-links-grid">
          {[
            { label: 'Truck & Trailer Finance', path: '/truck-and-trailer-finance' },
            { label: 'Equipment Finance', path: '/equipment-finance' },
            { label: 'Vehicle Finance', path: '/vehicle-finance' },
            { label: 'Business Loans', path: '/business-loans' },
          ].map((item) => (
            <Link key={item.path} to={item.path} className="rounded-xl border border-white/10 bg-navy-800/70 p-4 text-purple-300 hover:text-purple-200" data-testid={`not-found-link-${item.path.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}>
              {item.label}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
